export default "__VITE_ASSET__BQuIx68u__"